import React from 'react';
import Header from '../components/Header.jsx';

const AppLayout = ({ children, ...headerProps }) => {
  return (
    <div className="grid-container">
      <Header {...headerProps} />
      <main className="main-content">
        <div className="content-area">
          {children}
        </div>
      </main>
    </div>
  );
};

export default AppLayout;